import { format, getDate, addMonths, startOfMonth, parseISO } from 'date-fns';
import { HealthQuestion } from '@features/onboarding/components/6-health-question-form/interfaces';
import { t } from '@/i18n/index';

// Helper to generate date options
const createDateOption = (date: Date) => ({
  value: format(date, 'yyyy-MM-dd'),
  label: format(date, 'MMMM d, yyyy'),
});

// Generate dynamic date options
const today = parseISO(format(new Date(), 'yyyy-MM-dd'));
const firstOfNextMonth = startOfMonth(addMonths(today, 1));
const firstOfFollowingMonth = startOfMonth(addMonths(today, 2));

export const HEALTH_QUESTIONS: HealthQuestion[] = [
  {
    id: 'initialQuestions',
    question: '',
    type: 'initialQuestions',
    subQuestions: [
      'In the past 5 years, has anyone on this application (including you!) been recommended for treatment, received care, been advised to seek treatment, or had diagnostic testing for any condition? Or maybe been told you might need hospital visits, treatments, tests, or surgeries in the future?',
      'Are you or anyone listed on this application currently, partially, or fully disabled, using a wheelchair or motorized aid, hospitalized, bedridden, residing in a nursing facility, receiving hospice or home health care, or otherwise incapacitated?',
      'Are you, or anyone on the application, pregnant?',
    ],
  },
  {
    id: 'takingMedicationsNow',
    question:
      'Are you, or anyone listed on this application taking any medications? This includes any pills, creams, injections, liquids, inhalers, or pumps.',
    type: 'takingMedicationsNow',
  },
  // {
  //   id: 'medicalConditionsIntro',
  //   question: 'Time to talk about medical conditions.',
  //   type: 'info',
  // },
  {
    id: 'surgeriesDiabetesHeartMental',
    question: 'Surgeries, diabetes, heart, and mental health.',
    type: 'checkbox',
    description:
      'We think you know the drill by now. Our insurance carriers need to know if you or anyone on this application has been advised to seek treatment, undergone diagnostic testing, had surgery or been hospitalized for any of the things listed below.',
  },
  {
    id: 'medDetails',
    question: 'Let’s dig into the details',
    type: 'checkbox',
    description:
      'Thanks for letting us know about your condition(s)! Now we just need to find out a little more info about the item(s) you checked.',
  },
  {
    id: 'otherHealthConditions',
    question: 'Some other health conditions.',
    type: 'checkbox',
    description:
      'Has anyone on this application has been advised to seek treatment, undergone diagnostic testing, had surgery or been hospitalized for any of the things listed below?',
  },
  {
    id: 'coverageStartDate',
    question: 'When do you want coverage to start?',
    type: 'date',
    options: [
      createDateOption(firstOfNextMonth),
      createDateOption(firstOfFollowingMonth),
    ],
  },
  // {
  //   id: 'disclaimer',
  //   question: 'Please read the following disclamer:',
  //   type: 'disclaimer',
  // },
  {
    id: 'privacyDisclosure',
    question: 'And now a word from our lawyers. Sry!',
    type: 'disclaimer',
  },
  {
    id: 'congratulations',
    question: 'Let’s See Your Final Quote!',
    type: 'info',
  },
];
export const EXCLUDED_TEXTAREA_LABELS = [
  'Surgery that you are still being treated for, or have an upcoming surgery',
  'Heart Disease, Heart Attack, Stroke',
  'Mental Health',
  'Diabetes or PRE-diabetes',
];
export const STEP_PHQ_1_ERRORS = {
  treatment: t('errors.selectAnyValue'),
  invalid: t('errors.selectAnyValue'),
  pregnancy: t('errors.selectAnyValue'),
};

export const PLEASE_SELECT_LEAST = 'Please select at least one option.';

// Global toggle: when false, textarea details are optional. Set true to enforce.
export const REQUIRE_DETAILS = false;

export const HIDE_DETAILS_FOR = ['surgery', 'diabetes', 'heart', 'mental'];
